import { render } from "./avatars_Uikits.vue?vue&type=template&id=6dbecfc8"
import script from "./avatars_Uikits.vue?vue&type=script&lang=js"
export * from "./avatars_Uikits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__